import { IAutoCompleteResponseTransformed } from "./IAutoCompleteResponseTransformed";
interface IAutoCompleteResponse {
	placeId: string;
	structuredFormatting: {
		mainText: string;
		secondaryText: string;
	};
}
export class AddressAutocompleteService {
	private readonly _addressEndpoint: string;
	private readonly _bearerTokenEndpoint: string;
	private readonly _dxeBearerToken: Promise<string>;

	constructor(bearerTokenEndpoint: string, addressEndpoint: string) {
		this._addressEndpoint = addressEndpoint;
		this._bearerTokenEndpoint = bearerTokenEndpoint;
		this._dxeBearerToken = this.getDXEBearerToken(this._bearerTokenEndpoint);
	}

	public async getAddressSuggestions(
		userInput: string
	): Promise<IAutoCompleteResponseTransformed[] | undefined> {
		try {
			const endpointParam = `${
				this._addressEndpoint
			}?address=${encodeURIComponent(userInput)}`;
			const promise = $.ajax({
				beforeSend: xhr => {
					xhr.setRequestHeader(
						"authorization",
						`Bearer ${this._dxeBearerToken}`
					);
				},
				type: "GET",
				url: endpointParam
			});
			const result = (await Promise.resolve(promise)) as [
				IAutoCompleteResponse
			];
			console.log({ result });
			const resultsTransformed = this.transformResponseData(result);

			return resultsTransformed;
		} catch (err) {
			console.warn(`Error retrieving Address Suggestions:${err}`);
		}
	}

	private transformResponseData(
		response: IAutoCompleteResponse[]
	): IAutoCompleteResponseTransformed[] {
		const responseTransformed = response.map(item => {
			const {
				mainText,
				secondaryText
			}: {
				mainText: string;
				secondaryText: string;
			} = item.structuredFormatting;

			return {
				desc: secondaryText,
				label: mainText,
				placeId: item.placeId,
				value: `${mainText}, ${secondaryText}`
			};
		});

		return responseTransformed;
	}

	private async getDXEBearerToken(endpoint: string): Promise<string> {
		try {
			const promise = $.get(this._bearerTokenEndpoint);
			const result = await Promise.resolve(promise);
			// tslint:disable-next-line: no-unsafe-any
			console.log({ result });

			return result.data;
		} catch (err) {
			throw new Error(`Problem retrieving DXE Bearer Token: ${err}`);
		}
	}
}
